import React, { HTMLAttributes, SyntheticEvent } from 'react';
import cn from 'classnames';
import styles from './FormInputs.module.scss';

// Focus and hover states should work out of the box here, but consumers can also manage focus
// and hover states directly as needed (though consumers then also need to ensure that the default
// focus and hover state management by the browser is being blocked somehow).
interface CustomCheckboxProps {
  id: string;
  checked: boolean;
  onChange: (e: SyntheticEvent) => void;
  onClick?: (e: InputEvent) => void;
  focused?: boolean;
  hovered?: boolean;
}

type CheckboxProps = CustomCheckboxProps & HTMLAttributes<Element>;

export default function Checkbox({
  id,
  checked,
  onChange,
  className,
  focused,
  hovered,
  ...props
}: CheckboxProps) {
  return (
    <div
      className={cn(
        styles.checkbox,
        className,
        focused && styles.focused,
        hovered && styles.hovered,
      )}
    >
      <input id={id} type="checkbox" checked={checked} onChange={onChange} {...props} />
      <label htmlFor={id} className={styles.check}>
        <svg width="8px" viewBox="0 0 8 6">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.8"
            stroke="white"
            fill="none"
            d="M1.45 3.45l1.6 1.6l3.5-4"
          />
        </svg>
      </label>
    </div>
  );
}
